export default __webpack_public_path__ + "static/media/logo-icon-white.09ac425c.svg";